import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Row, Col, Label, Container, Alert } from 'reactstrap';
import numeral from 'numeral';

import DataCombobox from 'components/DataCombobox';
import SiteSummaryView from 'components/SiteSummaryView';
import MapComponent from 'pages/MapComponent';
// import SiteFinancialProjection from 'components/SiteFinancialProjection';
import SiteEdit from 'pages/SiteEdit';

import constants from '../../constants';
import api from '../../api';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class SiteDetailScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            site: {
                id: parseInt(this.props.match.params.location_id, 10) || '',
                description: '',
                name: '',
                segment_query: '',
            },
            labelNames: [],
            actions: [],
            isLoading: false,
            isValidating: false,
            isMapObjectClicked: false,
            segmentUserCount: 0,
            validationError: '',
            isAddNewAction: false,
            siteRejectionReasons: [],
            initialViewState: {
                longitude: 0,
                latitude: 0,
                zoom: 15,
                pitch: 0,
                bearing: 0
            },
        };
    }

    UNSAFE_componentWillMount() {
        this.getSiteDetail();
        this.getSiteRejectionReasons();
    }
    componentDidMount() {
        
    }

    getSiteDetail() {
        const { site } = this.state;
        this.setState({ isLoading: true });
        api.fetchAPI({
            method: 'get',
            uri: `location/${site.id}`,
            success: (response) => {
                const site = response.result;
                this.setState({
                    site,
                    labelNames: response.label_columns,
                    viewState: {
                        longitude: site.longitude,
                        latitude: site.latitude,
                        zoom: 15,
                        pitch: 0,
                        bearing: 0
                    },
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    getSiteRejectionReasons() {
        api.fetchAPI({
            method: 'get',
            uri: `site_rejection_reason/`,
            success: async (response) => {
                if (response.result) {
                    this.setState({
                        siteRejectionReasons: response.result,
                    });
                }
            },
            error: (error) => {
              alert(error.msg);
            },
        });
    }
    createNewAction() {
        this.setState({
            isAddNewAction: true,
        })
    }
    changeToDraft() {
        const confirmation = window.confirm(`Bạn sẽ đưa mặt bằng này thành bản nháp, khi đó bạn có thể chỉnh sửa?`);
        if (!confirmation) return;
        const { site } = this.state;
        site.site_dev_status = 'draft';
        this.setState({ site }, this.updateSite);
    }
    hideSite() {
        const confirmation = window.confirm(`Ẩn mặt bằng sẽ ẩn vĩnh viễn, không hiện lại ở bất kì đâu. Bạn chắc chứ?`);
        if (!confirmation) return;
        const { site } = this.state;
        site.is_active = 0;
        this.setState({ site }, this.updateSite);
    }
    approveSite() {
        const confirmation = window.confirm(`Bạn sẽ duyệt mặt bằng này?`);
        if (!confirmation) return;
        const { site } = this.state;
        api.fetchAPI({
            method: 'post',
            uri: `location/${site.id}/approve`,
            success: async (response) => {
                if (response.result) {
                    site.site_dev_status = response.result.site_dev_status;
                    this.setState({
                        site,
                    });
                }
            },
            error: (error) => {
                alert(error.message);
                this.setState({ isLoading: false });
            },
        });
    }
    submitSiteForApproval() {
        const confirmation = window.confirm(`Bạn sẽ đưa mặt bằng này cho sếp duyệt?`);
        if (!confirmation) return;

        // Data validation
        let validationPass = true;
        const { site, labelNames } = this.state;

        const alertMessage = [];

        constants.SITE_REQUIRED_FIELDS.map(requiredField => {
            if (!site[requiredField]) {
                const fieldName = labelNames[requiredField];
                alertMessage.push(`${fieldName} không được để trống`);
                validationPass = false;
            }
        });

        if (validationPass) {
            const { site } = this.state;
            api.fetchAPI({
                method: 'post',
                uri: `location/${site.id}/submit_for_approval`,
                success: async (response) => {
                    if (response.result) {
                        site.site_dev_status = response.result.site_dev_status;
                        this.setState({
                            site,
                        });
                    }
                },
                error: (error) => {
                    alert(error.message);
                    this.setState({ isLoading: false });
                },
            });
        } else {
            this.setState({
                alertMessage,
            });
        }
    }
    rejectSite() {
        this.setState({ isRejecting: true });
    }
    setRejectionReason(value) {
        const { site } = this.state;
        site.site_rejection_reason = value;
        this.setState({ site });
    }
    confirmRejectSite() {
        const confirmation = window.confirm(`Bạn sẽ từ chối mặt bằng này?`);
        if (!confirmation) return;
        const { site } = this.state;
        api.fetchAPI({
            method: 'post',
            uri: `location/${site.id}/reject`,
            success: async (response) => {
                if (response.result) {
                    site.site_dev_status = response.result.site_dev_status;
                    this.setState({
                        site,
                        isRejecting: false,
                    });
                }
            },
            error: (error) => {
                alert(error.message);
                this.setState({ isLoading: false });
            },
        });
    }
    updateSite() {
        const { site } = this.state;
        api.fetchAPI({
            method: 'put',
            uri: `location/${site.id}`,
            body: site,
            success: async (response) => {
                if (response.result) {
                    this.setState({
                        site,
                        isLoading: false,
                    });
                }
            },
            error: (error) => {
              alert(error.msg);
              this.setState({ isLoading: false });
            },
        });
    }
    updateAttr(attribute, value) {
        const { site } = this.state;
        site[attribute] = value;
        this.setState({ site });
    }
    onMapItemHover(hoveredObject, x, y) {
        this.setState({
            hoveredObject,
            pointerX: x,
            pointerY: y,
        });
    }
    onMapItemClick(hoveredObject, x, y) {
        this.setState({
            isMapObjectClicked: true,
            hoveredObject,
            clickedPointerX: x,
            clickedPointerY: y,
        });
    }
    _renderTooltip() {
        let { hoveredObject, pointerX, pointerY, isMapObjectClicked, clickedPointerX, clickedPointerY } = this.state || {};
        const { site } = this.state;
        
        return hoveredObject && (
            <div
                className="map_hover_tooltip" 
                style={{
                    position: 'absolute',
                    zIndex: 1,
                    left: isMapObjectClicked ? clickedPointerX : pointerX,
                    top: isMapObjectClicked ? clickedPointerY : pointerY,
                }}
            >
                {(hoveredObject.brand || hoveredObject.brand_name) &&
                    <span className="map_hover_tooltip_text brand">{hoveredObject.brand_name || hoveredObject.brand.name}<br /></span>
                }
                {site.id == hoveredObject.id &&
                    <span className="map_hover_tooltip_text selected-location">Địa điểm đang chọn<br /></span>
                }
                <span className="map_hover_tooltip_text">{ hoveredObject.address || hoveredObject.full_address || hoveredObject.name || '' }</span><br />
                {hoveredObject.location_type &&
                    <span className="map_hover_tooltip_text">Type: {hoveredObject.location_type_name || hoveredObject.location_type.name}<br /></span>
                }
                {hoveredObject.distance_in_km &&
                    <span className="map_hover_tooltip_text">Distance: {numeral(hoveredObject.distance_in_km * 1000).format('0,00')} m</span>
                }
            </div>
        );
    }
    render() {
        const {
            site, labelNames, isRejecting, isLoading,
            isMapObjectClicked, hoveredObject,
            viewState,
            alertMessage,
        } = this.state;
        if (!site) return null;
        if (isLoading) return (
            <div>Đang tải...</div>
        );
        
        let validLatLng = true;
        // Validate lat lng to avoid app crashing
        if (site.latitude < -90 || site.latitude > 90) {
            validLatLng = false;
        }

        if (site.longitude < -180 || site.longitude > 180) {
            validLatLng = false;
        }
        return (
            <Container>
                <div className="site-detail__wrapper">
                    <div className="site-detail_summary">
                        <div className="site-detail_site-name">
                            {(site.brand && site.brand && site.brand.brand_logo_image) &&
                                <img
                                    src={site.brand.brand_logo_image}
                                    alt={site.brand.name}
                                    className="site-detail_brand-logo"
                                />
                            }
                            {site.name && <span className="site-detail__site-name">{site.name}</span>}
                            {site.site_dev_status && <span className={`site-status-label ${site.site_dev_status}`}>{site.site_dev_status}</span>}
                        </div>
                        <p className="site-detail__full-address">
                            {site.address_number && site.street_name ?
                                <span>{site.full_address && `${labelNames.full_address}: ${site.full_address}`}</span>
                                :
                                <span>{site.address}</span>
                            }
                        </p>
                        <p className="site-detail_metric-single"><b>Diện tích</b>: {site.area} m2</p>
                        <p className="site-detail_metric-single"><b>Giá chủ mặt bằng chào</b>: {numeral(site.lease_rate).format('0,0')} VND</p>
                        <p className="site-detail_metric-single"><b>Visibility</b>: <span className={`site-detail_metric-visibility ${site.visibility}`}>{site.visibility}</span></p>
                        <p className="site-detail_metric-single"><b>Accessibility</b>: <span className={`site-detail_metric-accessibility ${site.accessibility}`}>{site.accessibility}</span></p>
                    </div>
                    {(alertMessage && alertMessage.length > 0) &&
                        <Row className="site-edit__error-message-on-save">
                            <Col xs={12}>
                                <Alert color="danger">
                                    <h4>Có lỗi xảy ra:</h4>
                                    <ol>
                                        {alertMessage.map(message => <li key={message}>{message}</li>)}
                                    </ol>
                                </Alert>
                            </Col>
                        </Row>
                    }
                    {!isRejecting &&
                        <Row>
                            <Col xs={12}>
                                {site.permissions &&
                                    <div className="site-detail__main-controls">
                                        {site.permissions?.includes('can_put') &&
                                            <div>
                                                {/* <Button
                                                    tag={Link}
                                                    to={`/site/${site.id}/traffic_scanning`}
                                                    onClick={() => this.rejectSite()}
                                                    color="primary"
                                                    className="site-detail__button-control"
                                                >
                                                    Đo traffic
                                                </Button> */}
                                                {!['waiting_for_approval', 'approved'].includes(site.site_dev_status) ?
                                                    <Button
                                                        tag={Link}
                                                        to={`/site/${site.id}/edit`}
                                                        onClick={() => this.rejectSite()}
                                                        color="info"
                                                        className="site-detail__button-control"
                                                    >
                                                        Chỉnh sửa
                                                    </Button>
                                                    :
                                                    <Button
                                                        onClick={() => this.changeToDraft()}
                                                        color="warning"
                                                        className="site-detail__button-control"
                                                    >
                                                        Chuyển thành nháp
                                                    </Button>
                                                }
                                                {site.site_dev_status == 'draft' &&
                                                    <Button
                                                        onClick={() => this.submitSiteForApproval()}
                                                        color="success"
                                                        className="site-detail__button-control"
                                                    >
                                                        Submit để duyệt
                                                    </Button>
                                                }
                                            </div>
                                        }
                                        {(site.permissions?.includes('can_approve_site') && site.site_dev_status !== 'draft') &&
                                            <div>
                                                {site.site_dev_status !== 'rejected' &&
                                                    <Button
                                                        onClick={() => this.rejectSite()}
                                                        color="danger"
                                                        className="site-detail__button-control"
                                                    >
                                                        Từ chối
                                                    </Button>
                                                }
                                                {site.site_dev_status !== 'approved' &&
                                                    <Button
                                                        onClick={() => this.approveSite()}
                                                        color="success"
                                                        className="site-detail__button-control"
                                                    >
                                                        Duyệt
                                                    </Button>
                                                }
                                            </div>
                                        }
                                        {site.permissions?.includes('can_deactivate_site') &&
                                            <Button
                                                onClick={() => this.hideSite()}
                                                color="dark"
                                                className="site-detail__button-control"
                                            >
                                                Ẩn mặt bằng
                                            </Button>
                                        }
                                    </div>
                                }
                            </Col>
                        </Row>
                    }
                    <Row>
                        {isRejecting &&
                            <Col xs={12} className="site-detail__rejection-reason-container">
                                <FormGroup>
                                    <h3>Lý do từ chối</h3>
                                    <DataCombobox
                                        apiUrl={'site_rejection_reason/'}
                                        onChange={(value) => this.setRejectionReason(value)}
                                        value={{ label: site.site_rejection_reason ? site.site_rejection_reason.name : '', value: site.site_rejection_reason ? site.site_rejection_reason.id : ''}}
                                        placeholder="Lý do từ chối"
                                    />
                                </FormGroup>
                                <Label>Ghi chú thêm về lý do hủy</Label>
                                <FormGroup>
                                    <TextareaAutosize
                                        type="textarea"
                                        className="custom-textarea"
                                        onChange={(e) => this.updateAttr('reject_reason', e.target.value)}
                                        value={site.reject_reason}
                                        placeholder="Ghi chú thêm cho việc từ chối"
                                        minRows={3}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Button
                                        onClick={() => this.confirmRejectSite()}
                                        color="danger"
                                        disabled={site.site_rejection_reason ? false : true}
                                    >
                                        Tiếp tục
                                    </Button>{' '}
                                    <Button
                                        onClick={() => this.setState({ isRejecting: false })}
                                        color="secondary"
                                        disabled={site.site_rejection_reason ? false : true}
                                    >
                                        Quay lại
                                    </Button>
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    {(validLatLng && site.latitude && site.longitude) ?
                        <Row>
                            <Col xs={12}>
                                {!isMapObjectClicked ?
                                    <div>
                                        <div className="site-detail__map">
                                            <MapComponent
                                                latitude={viewState.latitude}
                                                longitude={viewState.longitude}
                                                scanningRadius={2}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <SiteSummaryView
                                        site={hoveredObject}
                                        onBackClick={() => this.setState({ isMapObjectClicked: false })}
                                    />
                                }
                            </Col>
                        </Row>
                        :
                        <Row>
                            <Col xs={12}>
                                <p>Map will not show due to missing or invalid lat, lng...</p>
                            </Col>
                        </Row>
                    }
                    <SiteEdit match={{ params: { location_id: site.id }}} site={site} labelNames={labelNames} isView />
                </div>
            </Container>
        );
    }
}
